module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/CPU#2-e2ca9c2a883ac9e44904e768f8a2da8c28b71b734448e58f6d2871e29ab3cf23.svg";